import React from "react";
import { HiMiniCheckBadge } from "react-icons/hi2";

// Custom Components
import { Heading1, BoxText } from "../../../../components/Ui";

// Images
import images from "../../B2BDatabase/images";
import "../../../../assets/styles/main.css";
import "../../../../assets/styles/responsive.css";
import "../../../../assets/styles/section.module.css";

const B2bdatabaseHome = () => {

    let UnvellingMedia = [
        {
          img: (
            <img
              alt="my-img"
              src={images.unveil.Unveil1}
              style={{
                width: "48px", // Adjust the width of the icon
                height: "48px", // Adjust the height of the icon
              }}
            />
          ),
          mainheading: "Intelligent Lead Scoring",
          para: "Leverage Advanced Algorithms To Prioritize On Leads With The Highest Potential Your Conversion Efforts",
        },
        {
          img: (
            <img
              alt="my-img"
              src={images.unveil.Unveil2}
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          ),
          mainheading: "AI-Powered Predictive Analytics",
          para: "Harness The Power Of Artificial Intelligence To Predict Future Trends And Behaviors.",
        },
        {
          img: (
            <img
              alt="my-img"
              src={images.unveil.Unveil3}
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          ),
          mainheading: "Automated Email Campaigns",
          para: "Streamline Your Outreach With Automated Email Campaigns, Saving Time And Ensuring Consistent.",
        },
        {
          img: (
            <img
              alt="my-img"
              src={images.unveil.Unveil4}
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          ),
          mainheading: "Customizable Lead Forms",
          para: "Stay In The Know With A Dynamic Analytics Dashboard, Providing Real-Time Insights Into Your Campaign.",
        },
        {
          img: (
            <img
              alt="my-img"
              src={images.unveil.Unveil5}
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          ),
          mainheading: "Multi-channel Integration",
          para: "Seamlessly Connect With Your Audience Across Various Channels, Ensuring A Cohesive And Effective.",
        },
        {
          img: (
            <img
              alt="my-img"
              src={images.unveil.Unveil6}
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          ),
          mainheading: "Real-time Analytics Dashboard",
          para: "Leverage Advanced Algorithms To Prioritize On Leads With The Highest Potential Your Conversion Efforts.",
        },
      ];
      

  return (
    
<>      
{/* Strategy starts here */}
<section
  style={{
    width: "75%", // Adjust container width
    display: "flex",
    flexDirection: "column",
    gap: "1rem", // Space between flex items
    paddingTop: "1.25rem", // pt-5
    paddingBottom: "2.5rem", // py-10
    margin: "0 auto", // Center the section
    textAlign: "center", // Default text alignment
  }}
>
  {/* Title */}
  <div
    style={{
      margin: "0 auto",
      lineHeight: "1.2", // Tight line height
    }}
  >
    <Heading1 heading1="Elevate Your Strategy With Cutting-Edge Database Capabilities!" />
  </div>

  {/* Stats Grid */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)", // 2 columns by default
      gap: "1rem", // Space between grid items
    }}
  >
    {/* Individual Stat Items */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ color: "#56F444" }}>
        <Heading1 heading1="50M" />
      </div>
      <p
        style={{
          fontSize: "12px", // Text size
          fontWeight: "400", // Normal font weight
          color: "#7B7B7B", // Text color
          textAlign: "center",
        }}
      >
        Companies
      </p>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ color: "#56F444" }}>
        <Heading1 heading1="$12B" />
      </div>
      <p
        style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#7B7B7B",
          textAlign: "center",
        }}
      >
        Market Valuation
      </p>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ color: "#56F444" }}>
        <Heading1 heading1="500M" />
      </div>
      <p
        style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#7B7B7B",
          textAlign: "center",
        }}
      >
        Contacts
      </p>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ color: "#56F444" }}>
        <Heading1 heading1="3.5M" />
      </div>
      <p
        style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#7B7B7B",
          textAlign: "center",
        }}
      >
        Active Users
      </p>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ color: "#56F444" }}>
        <Heading1 heading1="25%" />
      </div>
      <p
        style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#7B7B7B",
          textAlign: "center",
        }}
      >
        Reduction in Costs
      </p>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ color: "#56F444" }}>
        <Heading1 heading1="80%" />
      </div>
      <p
        style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#7B7B7B",
          textAlign: "center",
        }}
      >
        Customer Retention Rate
      </p>
    </div>
  </div>
</section>

    {/* Beyond Leads */}
    <section
  style={{
    backgroundColor: "#F5F5F5", // Light gray background
    padding: "4rem 0", // Top and bottom padding
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <div
    style={{
      display: "flex",
      flexDirection: "row", // Align content side by side
      maxWidth: "1200px", // Limit the width of the section
      width: "100%",
      gap: "2rem", // Space between text and image
    }}
  >
    {/* Left Text Column */}
    <div
      style={{
        flex: 1, // Take up half the space
        display: "flex",
        flexDirection: "column",
        gap: "1rem", // Space between elements
        justifyContent: "center",
      }}
    >
      <div
        style={{
          textAlign: "left", // Align text to the left
        }}
      >
        <h1
          style={{
            fontSize: "30px",
            fontWeight: "700", // Bold heading
            marginBottom: "1rem",
            color: "#030621", // Dark text color
          }}
        >
          Beyond Leads: Unleash The Full Power Of Leadbud.Io!
        </h1>
      </div>
      {/* Media Object 1 */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "0.5rem", // Space between icon and text
        }}
      >
        <HiMiniCheckBadge
          style={{
            fontSize: "20px",
            color: "#56F444", // Green icon
          }}
        />
        <div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#030621",
              marginBottom: "0.25rem",
            }}
          >
            Market Insights
          </h3>
          <p
            style={{
              fontSize: "14px",
              color: "#7B7B7B", // Light gray text
              margin: 0,
            }}
          >
            Dive Deep Into Market Trends And Gain Valuable Insights To Stay Ahead Of The Competition.
          </p>
        </div>
      </div>
      {/* Media Object 2 */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "0.5rem", // Space between icon and text
        }}
      >
        <HiMiniCheckBadge
          style={{
            fontSize: "20px",
            color: "#56F444", // Green icon
          }}
        />
        <div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#030621",
              marginBottom: "0.25rem",
            }}
          >
            Market Insights
          </h3>
          <p
            style={{
              fontSize: "14px",
              color: "#7B7B7B", // Light gray text
              margin: 0,
            }}
          >
            Dive Deep Into Market Trends And Gain Valuable Insights To Stay Ahead Of The Competition.
          </p>
        </div>
      </div>
      {/* Button */}
      <div
        style={{
          marginTop: "1rem",
        }}
      >
        <button
          style={{
            backgroundColor: "#56F444", // Green gradient
            color: "#FFFFFF", // White text
            fontSize: "16px",
            padding: "0.75rem 2rem", // Adjust button size
            border: "none",
            borderRadius: "8px", // Rounded corners
            cursor: "pointer",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Start to Free
        </button>
      </div>
    </div>

    {/* Right Image Column */}
    <div
      style={{
        flex: 1, // Take up half the space
        textAlign: "center",
      }}
    >
      <img
        src={images.beyond} // Replace with your image
        alt="my-img"
        style={{
          width: "100%", // Responsive width
          height: "auto", // Maintain aspect ratio
        }}
      />
    </div>
  </div>
</section>

    {/* Unvelling section here */}
    <section
  style={{
    padding: "4rem 0", // Top and bottom padding
    display: "flex", // Use flexbox for alignment
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    flexDirection: "column", // Stack items vertically
    textAlign: "center", // Center-align content
  }}
>
  {/* Title */}
  <div
    style={{
      width: "75%", // md:w-3/4
      margin: "0 auto", // Center the title container
      lineHeight: "1.4", // Adjust line height
    }}
  >
    <h1
      style={{
        fontSize: "30px", // Heading font size
        fontWeight: "700", // Bold heading
        marginBottom: "2rem", // Space below the heading
        color: "#030621", // Dark text color
      }}
    >
      Unveiling Excellence: Features That Redefine Possibilities!
    </h1>
  </div>

  {/* Features Grid */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)", // Single column by default
       gap: "1.5rem", // Space between grid items
      marginTop: "2rem", // Top margin for spacing
      width: "75%", // Limit grid width
    }}
  >
    {UnvellingMedia.map((data, index) => (
      <div
        key={index}
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "1rem", // Space between icon and text
        }}
      >
        {/* Icon */}
        <div
          style={{
            flexShrink: "0", // Prevent the icon from shrinking
            fontSize: "32px", // Icon size
            color: "#56F444", // Green color for the icon
          }}
        >
          {data.img}
        </div>
        {/* Text Content */}
        <div style={{ textAlign: "left" }}>
          <h3
            style={{
              fontSize: "12px", // Title font size
              fontWeight: "600", // Semi-bold text
              marginBottom: "0.5rem", // Space below the heading
              color: "#030621", // Dark text color
            }}
          >
            {data.mainheading}
          </h3>
          <p
            style={{
              fontSize: "10px", // Paragraph font size
              color: "#7B7B7B", // Light gray text
              margin: 0, // Remove default margin
            }}
          >
            {data.para}
          </p>
        </div>
      </div>
    ))}
  </div>
</section>

    {/* elevate strategy box  */}
    <section className='container text-center my-5'>
      <BoxText heading1="Elevate Your Strategy: Take Action Now!" para="Seize the opportunity to transform your approach to success. Click now to unlock the full potential of our features and revolutionize your business strategy." btn1="Start to Free" />
    </section>
    
    </>
  );
};

export default B2bdatabaseHome;
